<div class="flex flex-col gap-20">
  <div class="flex items-center justify-center">
    <span
      class="text-primary text-2xl border-[2px] border-transparent border-b-primary p-4"
    >
      OTP Verification</span
    >
  </div>
  <div class="flex flex-col gap-5">
    <div class="flex gap-8 items-center justify-center w-full">
      <input class="h-8 w-6 border border-gray-400 shadow-inner outline-none" />
      <input class="h-8 w-6 border border-gray-400 shadow-inner outline-none" />
      <input class="h-8 w-6 border border-gray-400 shadow-inner outline-none" />
      <input class="h-8 w-6 border border-gray-400 shadow-inner outline-none" />
      <input class="h-8 w-6 border border-gray-400 shadow-inner outline-none" />
      <input class="h-8 w-6 border border-gray-400 shadow-inner outline-none" />
    </div>
    <div class="w-full items-center justify-center flex">Resend OTP?</div>
  </div>
  <div class="items-center justify-center flex w-full">
    <app-secondary-button routerLink="/home" class="w-32">
      <div class="gap-2 flex items-center justify-center">
        <img src="../../assets/image/Shape.png" alt="" class="h-4" />
        verify
      </div>
    </app-secondary-button>
  </div>
</div>
